/*
Sohel  12/19/2022 3075154998 Added data manager Record Screen Stepper
Sohel  12/19/2022 3075154998 label Changes.
Sohel  12/21/2022 3075154998 changed label.
Akhila 12/21/2022 3075154998 Added Field Select Screen
Lalitha 12/21/2022 3075154998 Rename Field Select to Select Process Fields
kavyareddy 12/30/2022 3075154998 Added filter criteria in steps
Sohel 01/07/2023 2698964415 Added Filter Criteria Screen
dilip 01/08/2023 3075154998 Added Completed steps functionality
dilip 01/10/2023 3075154998 Added unsaved popup.
Sohel 01/11/2023 3075154998 changed Stepper position.
Sohel 01/12/2023 3075154998 Added download configuration condition
dilip 01/12/2023 3075154998 Added Conditions for Exception Records.
Ashraf 01/13/2023 3075154998 fixed toast messages and loaders
Sohel 01/16/2023 3075154998 fixed stepper completed status issue
sai krishna 01/16/2023 3075154998 add code and description ,type
Sohel 01/19/2023 2699714747 Download Configuration payload changes
Sohel 01/20/2023 2698964415 Added Last Step in Stepper
Sohel 01/25/2023 2698964415 completed Status changes
dilip 01/25/2023 2698964415 Filter criteria changes for Data Update.
Sohel 01/31/2023 2698964415 fixed completed Status issue
Sohel 01/31/2023 2698964415 payload changes
sai krishna 02/03/2023 2698964415 updated download configuration payload
Sohel 02/08/2023 2701335619 Implement Usage Functionality
suresh peddavoora 02/22/2023 2701335619 New UI changes fixed
Raghu 02/23/2023 2701335619 added new class for stepper line
Dilip 02/24/2023 2698964415 implemented preview file functionality in download configuration
Ravi 03/01/2023 2698964415 Added loader and download toast message for preview File
Ravi 03/08/2023 2698964415 rename Filter Criteria to Duplicate Criteria
Sohel 03/08/2023 2701335619 hide Filter Criteria based on Duplicate Check
Sohel 03/10/2023 2698964415 added StepIconComponent for showing Numbers in StepLabel
Sohel 03/15/2023 2701335619 hide Duplicate Criteria Based on condition
Prakash 03-23-23 2701335619 fixed alignments issue in account summary.
Akhila 04/10/2023 2701335619 unsaved changes bug fixed
Prakash 19/04/2023 2701335619 remove padding issue .
Prakash 19/04/2023 2701335619 fixed stpper issue in tab view.
Akhila 05/31/2023 2701335619 unsaved changes bug fixed
Ravi 06/09/2023 2701335619 Added Breadcrums in preview
Akhila 06/12/2023 2701335619 added role access
Sohel 12/12/2023 2701335619 label name change code to name 
*/
import {Button, makeStyles, Stepper, StepLabel, Step} from '@material-ui/core';
import React, {useState, useEffect, useRef} from 'react';
import reusableInputStyles from '../../../../../components/InputStyles';
import {backButtonText, downloadButton} from '../../../../../util/Content';
import {ArrowBack} from '@material-ui/icons';
import StepConnector from '@material-ui/core/StepConnector';
import {withStyles} from '@material-ui/core/styles';
import DMRBasicInfo from './DMRBasicInfo';
import DMRRecordFormatFields from './DMRRecordFormatFields';
import DMRProcessorGroup from './DMRProcessorGroup';
import DMRFieldSelect from './DMRFieldSelect';
import DMRFilterCriteria from './DMRFilterCriteria';
import DMRFilterCriteriaImport from './DMRFilterCriteriaImport';
import {useDispatch, useSelector} from 'react-redux';
import useUnsavedChangesWarning from './../../../../../util/CustomHooks';
import {setAlertData} from '../../../../../redux/reducers/UnsavedChangesAlertReducer';
import {
  postPrintImportRecordGroup,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/DataManagerRecord';
import {setRecordGroupRedux} from '../../../../../redux/reducers/DataManagerRecordGroup';
import {postPrintUsage} from '../../../../../redux/reducers/printUsage';
import axios from 'axios';
import PageLoader from '../../../../../components/PageLoader';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';
import NumberStepIcon from '../../../../../components/customStepIcon/index';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 'bold',
        [theme.breakpoints.down('md')]: {
          fontSize: '0.75rem',
        },
      },
    },
  },
}));

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);
const masterRecordOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];
const AddDataManagerRecord = ({
  setValue,
  exportManagerRecord,
  editExisting,
  dmTempRecordAccess,
  exportRecordGroupAccess,
  importRecordGroupAccess,
}) => {
  const stepperClasses = useStyles();
  const classes = reusableInputStyles();
  const {basicInfoData, isDraftRecord, lastStep, configurationUrl, dockey, isAccountNumbers} =
    useSelector(({dataManagerRecord}) => dataManagerRecord);
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option || item.key === option || item.categoryCode === option) {
          label = item;
        }
      });
    return label;
  };
  const dispatch = useDispatch();
  const {onDirty, onPristine} = useUnsavedChangesWarning();
  const showAlertRef = useRef(false);
  const [activeStep, setActiveStep] = useState(isDraftRecord === 'N' ? 0 : lastStep);
  const [exceptionType, setExceptionType] = useState(false);
  const usageType = exportManagerRecord ? 'EXPORT TEMPLATE RECORD' : 'IMPORT TEMPLATE RECORD';
  const [hidden, setHidden] = useState(false);
  const [hideDuplicateCriteria, setHideDuplicateCriteria] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  useEffect(() => {
    if (configurationUrl) {
      setIsLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);
  const [steps, setSteps] = useState([
    'Basic Info',
    'Record Format Fields',
    'Select Transformation Fields',
    'Add Transformation Group',
  ]);
  useEffect(() => {
    if (exceptionType) {
      setSteps(['Basic Info', 'Fields']);
    } else {
      if (hidden && !hideDuplicateCriteria) {
        setSteps([
          'Basic Info',
          'Fields',
          'Transformation Fields',
          'Duplicate Criteria',
          'Transformation Group',
        ]);
      } else {
        setSteps(['Basic Info', 'Fields', 'Transformation Fields', 'Transformation Group']);
      }
      // else {
      //   if (hidden && hideDuplicateCriteria) {
      //     setSteps([
      //       "Basic Info",
      //       "Fields",
      //       "Preprocessor Fields",
      //       "Preprocessor Group",
      //       "Duplicate Criteria",
      //     ]);
      //   }
    }
  }, [hidden, exceptionType, hideDuplicateCriteria]);
  const type = exportManagerRecord ? 'Export' : 'Import';
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const masterRecord =
    type === 'Import' && basicInfoData?.masterRecord ?
      getObject(basicInfoData?.masterRecord, masterRecordOptions) :
      {key: 'N', value: 'No'};
  useEffect(() => {
    if ('masterRecord' in basicInfoData) {
      dispatch(
        setRecordGroupRedux({
          property: 'masterRecord',
          value: masterRecord,
        }),
      );
      if (basicInfoData?.recordType === 'Exception') {
        setExceptionType(true);
      }
    }
    const hide = ['New Account Import']?.includes(basicInfoData?.recordType) ?
      masterRecord?.key === 'Y' && basicInfoData?.duplicateCheck === 'Y' :
      ['Data Update']?.includes(basicInfoData?.recordType) ?
        masterRecord?.key === 'Y' :
        false;
    setHidden(hide);
  }, [basicInfoData?.recordType]);
  useEffect(() => {
    if (isAccountNumbers === 'Y') {
      setHideDuplicateCriteria(true);
    } else {
      setHideDuplicateCriteria(false);
    }
  }, [isAccountNumbers]);
  const handleBack = () => {
    if (showAlertRef.current) {
      dispatch(
        setAlertData({
          showAlert: showAlertRef.current,
          alertCallback: () => {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
          },
        }),
      );
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  const isNewBusinessRecords = [
    'New Account Import',
    'New Payment Import',
    'Data Update',
  ]?.includes(basicInfoData?.recordType);
  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        <DMRBasicInfo
          activeStep={activeStep}
          handleNext={handleNext}
          exportManagerRecord={exportManagerRecord}
          hideRule={(e) => setHidden(e)}
          setExceptionType={setExceptionType}
          exceptionType={exceptionType}
          dmTempRecordAccess={dmTempRecordAccess}
          editExisting={editExisting}
          exportRecordGroupAccess={exportRecordGroupAccess}
          importRecordGroupAccess={importRecordGroupAccess}
          {...alertProps}
        />
      );
    case 1:
      return (
        <DMRRecordFormatFields
          handleBack={handleBack}
          handleNext={handleNext}
          exportManagerRecord={exportManagerRecord}
          exceptionType={exceptionType}
          hideDuplicateCriteria={hideDuplicateCriteria}
          hideFilterCriteriaRule={(e) => setHideDuplicateCriteria(e)}
          setValue={setValue}
          dmTempRecordAccess={dmTempRecordAccess}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    case 2:
      return (
        <DMRFieldSelect
          handleBack={handleBack}
          handleNext={handleNext}
          exportManagerRecord={exportManagerRecord}
          dmTempRecordAccess={dmTempRecordAccess}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    case 4:
      return (
        <DMRProcessorGroup
          handleBack={handleBack}
          setValue={setValue}
          handleNext={handleNext}
          exportManagerRecord={exportManagerRecord}
          hidden={hidden}
          dmTempRecordAccess={dmTempRecordAccess}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    case 3:
      return (
        <>
          {hidden && !hideDuplicateCriteria ? (
            isNewBusinessRecords ? (
              <DMRFilterCriteriaImport
                handleBack={handleBack}
                handleNext={handleNext}
                exportManagerRecord={exportManagerRecord}
                setValue={setValue}
                dmTempRecordAccess={dmTempRecordAccess}
                editExisting={editExisting}
                {...alertProps}
              />
            ) : (
              <DMRFilterCriteria
                handleBack={handleBack}
                handleNext={handleNext}
                exportManagerRecord={exportManagerRecord}
                setValue={setValue}
                dmTempRecordAccess={dmTempRecordAccess}
                editExisting={editExisting}
              />
            )
          ) : (
            <DMRProcessorGroup
              handleBack={handleBack}
              setValue={setValue}
              handleNext={handleNext}
              exportManagerRecord={exportManagerRecord}
              hidden={hidden}
              {...alertProps}
              dmTempRecordAccess={dmTempRecordAccess}
              editExisting={editExisting}
              exportRecordGroupAccess={exportRecordGroupAccess}
              importRecordGroupAccess={importRecordGroupAccess}
            />
          )}
        </>
      );
    }
  };
  return (
    <>
      <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setValue(0);
                  },
                }),
              );
            } else {
              setValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>

        {basicInfoData?.recordCode && (
          <div>
            <Button
              type="button"
              variant="outlined"
              className={`mx-1 search-btn`}
              onClick={(event) => {
                dispatch(
                  postPrintUsage({
                    baseCategory: '',
                    code: '',
                    description: '',
                    displayName: '',
                    fileType: '',
                    recordFormatType: '',
                    returnType: '',
                    sourceType: usageType,
                    isDraft: '',
                    masterRecord: basicInfoData?.masterRecord ? basicInfoData?.masterRecord : '',
                    search: '',
                    frameworkUsageOrderBy: '',
                    frameworkUsageOrderDerection: '',
                    fieldListOrderBy: '',
                    fieldListOrderDerection: '',
                    category: basicInfoData?.category ? basicInfoData?.category : '',
                    fieldName: '',
                    repositoryDescription: '',
                    repositoryName: '',
                    repositoryType: '',
                    createdBy: '',
                    recordCode: basicInfoData?.recordCode ? basicInfoData?.recordCode : '',
                    recordType: basicInfoData?.recordType ? basicInfoData?.recordType : '',
                    recordDescription: basicInfoData?.recordDescription ?
                      basicInfoData?.recordDescription :
                      '',
                    createdDate: '',
                    includeAudit: basicInfoData?.includeAudit ? basicInfoData?.includeAudit : '',
                  }),
                );
              }}
            >
              Download Configuration Usage
            </Button>
            <Button
              type="button"
              variant="outlined"
              className={`search-btn ml-2 ${classes.buttonRoot}`}
              onClick={() => {
                dispatch(
                  postPrintImportRecordGroup(
                    {
                      recordCode: basicInfoData?.recordCode ? basicInfoData?.recordCode : '',
                      recordType: basicInfoData?.recordType ? [basicInfoData?.recordType] : [],
                      recordDescription: basicInfoData?.recordDescription ?
                        basicInfoData?.recordDescription :
                        '',
                      createdDate: '',
                      orderDirection: '',
                      orderBy: '',
                      isDraft: '',
                      printIndividual: 'Y',
                      masterRecord: basicInfoData?.masterRecord ? basicInfoData?.masterRecord : '',
                      type: type,
                    },
                    type,
                  ),
                );
              }}
            >
              {downloadButton}
            </Button>
          </div>
        )}
      </div>

      <div className={'${classes.root} responsiveStepper'}>
        <Stepper
          activeStep={activeStep}
          connector={<QontoConnector />}
          style={{justifyContent: 'center'}}
        >
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={index < activeStep || index <= basicInfoData?.lastStep}
              style={{cursor: 'pointer'}}
              onClick={() => {
                if (index <= basicInfoData?.lastStep) {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(index);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(index);
                  }
                } else if (index < activeStep) {
                  setActiveStep(index);
                }
              }}
            >
              <StepLabel
                className={`${stepperClasses.stepperIcon} ${
                  activeStep === index ? 'completedStyle' : null
                }`}
                StepIconComponent={NumberStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div style={{padding: '1.2rem 0.5rem'}}>{getStepContent(activeStep)}</div>
        </div>
      </div>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={exportManagerRecord ? 'Export Template Record' : 'Import Template Record'}
        name={exportManagerRecord ? 'Export Template Record Name' : 'Import Template Record Name'}
        code={basicInfoData?.recordCode}
        description={
          exportManagerRecord ?
            'Export Template Record Description' :
            'Import Template Record Description'
        }
        descriptionValue={basicInfoData?.recordDescription}
      />
      {loading && <PageLoader />}
    </>
  );
};

export default AddDataManagerRecord;
